import { Text, TextProps } from 'grommet'
import { useTranslation } from 'next-i18next'

import { formatDate, formatRelativeDate } from 'util/date'

type Props = {
  date: string | number | Date
}

export function GroupDateInfo({ date, ...props }: Props & TextProps) {
  const {
    t,
    i18n: { language },
  } = useTranslation()
  return (
    <Text title={formatDate(date)} {...props}>
      {t('components.group-date-info.created')} {formatRelativeDate(date, language)}
    </Text>
  )
}
